import { computed, inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from '@ngrx/signals';
import { withDevtools } from '@ngrx-toolkit/core';
import { ApiService } from 'src/api';
import { Club } from 'src/api/models';
import { withApiOperation } from './features/with-api-operation.feature';
import { withRequestStatus } from './features/with-request-status.feature';

interface ClubsState {
  clubs: Club[];
}

const initialState: ClubsState = {
  clubs: [],
};

export const ClubsStore = signalStore(
  withDevtools('clubs'),
  withRequestStatus(),
  withApiOperation(),
  withState(() => initialState),
  withComputed(store => ({
    clubsLoaded: computed(() => store.clubs().length > 0),
  })),
  withMethods(store => {
    const apiClient = inject(ApiService);

    return {
      clubName: (id: string) =>
        store.clubs().find(club => club.id === id)?.name ?? '',
      clubLogo: (id: string) =>
        store.clubs().find(club => club.id === id)?.logo ?? '',
      async getClubs() {
        if (store.clubsLoaded()) {
          return;
        }

        await store.runApiOperation({
          request: apiClient.clubsGet({}),
          onSuccess: clubs => {
            patchState(store, { clubs });
            store.setLoaded();
          },
          onError: error => store.handleApiError(error),
        });
      },
    };
  }),
);
